import type { App } from 'vue';

export * from './src';

export const StuutUI = {
  install: (app: App) => {},
};
